/*@flow*/
import { css, jsx } from '@emotion/core';
import type { Element } from 'react';
import React, { useState } from 'react';

type PropsT = {
  name: string,
  min: ?number,
  max: ?number,
  minValue: ?number,
  maxValue: ?number,
  onChange: Function,
};

function mkNum(el) {
  return parseInt(el.target.value || '0', 10);
}

function RangeInputField({ min, max, step, name, value, onChange }) {
  const [localValue, setValue] = useState(value);
  const onCommit = () => onChange(localValue);
  const isDisabled = value === localValue;

  return (
    <div data-testid="RangeInputField">
      <input
        type="number"
        className="form-control text-control"
        min={min}
        max={max}
        step={step}
        maxLength={10}
        name={name}
        value={localValue}
        onChange={(el) => {
          setValue(mkNum(el));
        }}
      />
      <button
        data-tesid="Commit"
        className="btn btn-link p-0 mt-2"
        css={css('font-size: 1.2rem; color: #6394c4')}
        onClick={onCommit}
        disabled={isDisabled}
      >
        <i className="far fa-check-circle" /> Apply
      </button>
    </div>
  );
}

export default (props: PropsT): Element<'div'> => {
  const { name, min, max, onChange, maxValue, minValue } = props;
  const minName = `${name}[min]`;
  const maxName = `${name}[max]`;
  const step = 1;

  return (
    <div className="row">
      <div className="col-lg-6 col-md-6">
        <label className="col-form-label">Min</label>
        <RangeInputField
          min={min}
          max={max}
          step={step}
          name={minName}
          value={minValue}
          onChange={(value) => {
            if (value === 0 && !maxValue) {
              onChange(undefined);
            } else {
              onChange({ min: value, max: maxValue });
            }
          }}
        />
      </div>
      <div className="col-lg-6 col-md-6">
        <label className="col-form-label">Max</label>
        <RangeInputField
          name={maxName}
          min={min}
          max={max}
          step={step}
          value={maxValue}
          onChange={(value) => {
            if (value === 0 && !minValue) {
              onChange(undefined);
            } else {
              onChange({ min: minValue, max: value });
            }
          }}
        />
      </div>
    </div>
  );
};
